import { createActions, asyncAction } from '../helpers/redux';
import { schema, normalize } from 'normalizr';

const baselineSchema = new schema.Entity('baselines');

export const BaselineActions = createActions({
  @asyncAction()
  async getProjectBaselinesList(projectId) {
    return ({ client }) =>
      client
        .get(`/projects/${projectId}/baselines`)
        .then(response => normalize(response, [baselineSchema]));
  },

  @asyncAction()
  async createBaseLine(projectId, baseLine) {
    return ({ client }) =>
      client
        .post(`/projects/${projectId}/baselines`, {
          body: baseLine,
        })
        .then(response => normalize(response, baselineSchema));
  },

  @asyncAction()
  async deleteBaseLine(projectId, baselineId) {
    return ({ client }) =>
      client
        .delete(`/projects/${projectId}/baselines/${baselineId}`)
        .then(() => ({
          projectId,
          baselineId,
        }));
  },

});



// WEBPACK FOOTER //
// ./src/actions/baseline.js